"use client";

import styles from "./ForgotPasswordResetFormHeader.module.scss";
import { useTranslations } from "@/i18n";

/**
 * ForgotPasswordResetFormHeader Component
 *
 * Header section for password reset form with title and instructions.
 * Provides clear guidance for users on the password reset process.
 */
export const ForgotPasswordResetFormHeader = () => {
  const t = useTranslations("forgotPassword.formHeader");

  return (
    <div className={styles["comp"]}>
      {/* Main heading with emphasis on "Forgot" */}
      <h1
        className={styles["comp__header"]}
        dangerouslySetInnerHTML={{ __html: t.raw("title") }}
      />

      {/* Instructions for user */}
      <div className={styles["comp__subtitle"]}>{t("subtitle")}</div>
    </div>
  );
};
